// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__23qHk","header":"ReportDetails_header__3_Dty","title":"ReportDetails_title__3jdWJ","left":"ReportDetails_left__25GxE"};